//存健康数据
export const GET_INDEX_HEALTHY_DATA = "get_index_healthy_data";
//请求健康数据
export const REQ_INDEX_HEALTHY_DATA = "req_index_healthy_data";
